export default {
  getAllSteps: state => {
    return {
      intro: state.intro,
    };
  },
};
